import img01Bureau4Postes from "@/assets/images/client-mars-2026/img-01-bureau-4-postes.jpg";
import img02OpenSpace from "@/assets/images/client-mars-2026/img-02-open-space.jpg";
import img04Bureau10Postes from "@/assets/images/client-mars-2026/img-04-bureau-10-postes.jpg";
import img06OpenSpace from "@/assets/images/client-mars-2026/img-06-open-space.jpg";
import img07Bureau4p from "@/assets/images/client-mars-2026/img-07-bureau-4p.jpg";
import img09OpenSpace2 from "@/assets/images/client-mars-2026/img-09-open-space-2.jpg";
import img10OpenSpace1 from "@/assets/images/client-mars-2026/img-10-open-space-1.jpg";
import img11Sdr1 from "@/assets/images/client-mars-2026/img-11-sdr-1.jpg";
import img12Sdr2 from "@/assets/images/client-mars-2026/img-12-sdr-2.jpg";
import img14Bureau10Postes2 from "@/assets/images/client-mars-2026/img-14-bureau-10-postes-2.jpg";
import img15Bureau6Postes from "@/assets/images/client-mars-2026/img-15-bureau-6-postes.jpg";
import img16Amalfi from "@/assets/images/client-mars-2026/img-16-amalfi.jpg";
import img19Miami from "@/assets/images/client-mars-2026/img-19-miami.jpg";
import img33SdrCafet from "@/assets/images/client-mars-2026/img-33-sdr-cafet.jpg";

import { StaticImageData } from "next/image";

export type Offer = {
  id: string;
  contactOfferType:
    | "open-space-partage"
    | "bureaux-fermes"
    | "plateau-privatif"
    | "etage-entier"
    | "salles-reunion"
    | "autre";
  shortDescription: string;
  longDescription: string;
  name: string;
  cardPhoto: StaticImageData;
  photos: StaticImageData[];
  capacity?: string;
  prix: string;
  prixDescription?: string;
  priceLabel?: string;
  discoverable?: boolean;
};

type Offers = {
  sharedOpenSpace: Offer;
  privateOpenSpace: Offer;
  privateOffices: Offer;
  entireFloor: Offer;
  meetingRooms: Offer;
};

export const offersData: Offers = {
  sharedOpenSpace: {
    id: "open-space-partage",
    contactOfferType: "open-space-partage",
    name: "Open space partagé",
    shortDescription:
      "Un espace de coworking lumineux pensé pour travailler efficacement dans un cadre simple et convivial.",
    longDescription:
      "Un espace situé au 1er étage, organisé en benches de 2 à 8 personnes avec un bon équilibre entre convivialité et concentration.",
    cardPhoto: img02OpenSpace,
    photos: [img02OpenSpace],
    capacity: "22 postes fixes",
    prix: "380",
    priceLabel: "à partir de 380 €/mois",
    prixDescription: "Accès illimité à l'espace partagé et aux commodités",
    discoverable: true,
  },
  privateOpenSpace: {
    id: "open-space-prive",
    contactOfferType: "plateau-privatif",
    name: "Plateau privatif",
    shortDescription:
      "Une solution privative pour les équipes qui veulent un espace dédié et cohérent.",
    longDescription:
      "Trois plateaux privatifs adaptés aux entreprises qui veulent travailler ensemble dans un espace réservé.",
    cardPhoto: img06OpenSpace,
    photos: [img06OpenSpace, img09OpenSpace2, img10OpenSpace1],
    capacity: "3 plateaux de 20 postes",
    prix: "0",
    priceLabel: "sur demande",
    prixDescription: "Plateau privatif complet avec espaces de confidentialité",
    discoverable: true,
  },
  privateOffices: {
    id: "bureaux-fermes",
    contactOfferType: "bureaux-fermes",
    name: "Bureaux fermés",
    shortDescription:
      "Des bureaux fermés modernes et lumineux, conçus pour offrir confort, calme et confidentialité.",
    longDescription:
      "Des bureaux fermés de 3 à 10 postes, pensés pour allier concentration et souplesse pour les équipes.",
    cardPhoto: img01Bureau4Postes,
    photos: [
      img01Bureau4Postes,
      img04Bureau10Postes,
      img07Bureau4p,
      img14Bureau10Postes2,
      img15Bureau6Postes,
      img11Sdr1,
    ],
    capacity: "de 3 à 10 postes",
    prix: "1500",
    priceLabel: "à partir de 1 500 €/mois",
    prixDescription: "Bureaux fermés pour équipes de différentes tailles",
    discoverable: true,
  },
  entireFloor: {
    id: "etage-entier",
    contactOfferType: "etage-entier",
    name: "Étage entier",
    shortDescription:
      "Une formule complète pour les entreprises qui veulent privatiser un ensemble cohérent.",
    longDescription:
      "Un étage complet avec une combinaison de zones ouvertes et d'espaces de travail dédiés.",
    cardPhoto: img10OpenSpace1,
    photos: [img10OpenSpace1, img12Sdr2, img11Sdr1],
    capacity: "30 postes",
    prix: "0",
    priceLabel: "sur demande",
    prixDescription: "Étage complet avec espaces de travail dédiés",
    discoverable: true,
  },
  meetingRooms: {
    id: "salles-de-reunion",
    contactOfferType: "salles-reunion",
    name: "Salles de réunion",
    shortDescription:
      "Des salles de réunion de capacités variables, accessibles dans le contrat.",
    longDescription:
      "Des salles adaptées aux réunions d'équipe, ateliers et rendez-vous clients.",
    cardPhoto: img16Amalfi,
    photos: [img16Amalfi, img19Miami, img33SdrCafet],
    capacity: "de 3 à 16 personnes",
    prix: "0",
    priceLabel: "inclus dans le contrat",
    prixDescription: "Salles de réunion et équipements inclus",
    discoverable: false,
  },
};
